import Vue from 'vue';
import VueRouter from 'vue-router';

import { LocalStorage } from 'quasar';
import routes from './routes';

Vue.use(VueRouter);

/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */

export default function () {
  const Router = new VueRouter({
    scrollBehavior: () => ({ x: 0, y: 0 }),
    routes,

    // Leave these as they are and change in quasar.conf.js instead!
    // quasar.conf.js -> build -> vueRouterMode
    // quasar.conf.js -> build -> publicPath
    mode: process.env.VUE_ROUTER_MODE,
    base: process.env.VUE_ROUTER_BASE,
  });

  Router.beforeEach((to, from, next) => {
    // Redirect to /pin if validPin is false
    if (to.path !== '/pin' && !LocalStorage.has('pin')) {
      next({ path: '/pin', replace: true });
    }
    else if (to.path !== '/tables'
      && LocalStorage.has('pin')
      && !LocalStorage.has('user')) {
      next({ path: '/tables', replace: true });
    }
    else if ((to.path === '/tables' || to.path === '/pin')
            && LocalStorage.has('pin') && LocalStorage.has('user')) {
      next({ path: '/customer', replace: true });
    }
    else {
      next();
    }
  });

  return Router;
}
